// --------- App Specific Keywords --------- //

const APP_KEYWORDS = {
	getUserWithTokens: "getUserWithTokens",
	RUser: "retrieveUser",
	createCustomer: "createCustomer",
	RCustomers: "retrieveCustomers",
	UCustomers: "updateCustomers",
	RProducts: "retrieveProducts",
	RProductCategories: "retrieveProductCategories",
	ROrders: "retrieveOrders",
	RServiceRequests: "retrieveServiceRequests",
	RBackorderedOrders: "retrieveBackorderedOrders",
	COrders: "createOrders",
	UOrders: "updateOrders",
	UOrderStatus: "updateOrderStatus",
	UCartItemStatus: "updateCartItemStatus",
	// Admin Product & Category Keywords
	adminListTrashedProducts: "adminListTrashedProducts",
	adminCreateProduct: "adminCreateProduct",
	adminUpdateProduct: "adminUpdateProduct",
	adminUpdateProductImage: "adminUpdateProductImage",
	adminTrashProduct: "adminTrashProduct",
	adminRestoreProduct: "adminRestoreProduct",
	adminListTrashedCategories: "adminListTrashedCategories",
	adminCreateCategory: "adminCreateCategory",
};

export default APP_KEYWORDS;
